export default "__VITE_ASSET__CGSGjqzB__"